import hh from "hyperscript-helpers";
import {h} from "virtual-dom";
import {
    anyTextInputMsg,
    keywordSelectMsg,
    kommuneNoInputMsg, kommuneNoSelectInputMsg,
    rapportIdInputMsg,
    dguNrInputMsg,
    searchMsg,
    showDetailMsg, showNextSearchMsg, showPreviousSearchMsg
} from "../Update";
import { getSubmitButton } from "./View";

const { div, main, nav, a, fieldset, legend, span, i,
    label, input, pre, option, button, select,
    form, table, td, tr, th, tbody,thead } = hh(h);

function getSelectedOptions(selectId, dispatch, inputMsg) {
    const selectElement = document.querySelector('#'+ selectId);
    const selectedOptionValues = [...selectElement.options].filter(el => el.selected).map(el => el.value );
    dispatch(inputMsg(selectedOptionValues));
}
export function formView(dispatch, model) {
    return main({ className: 'pa1 pa2-ns black-80' }, [
        div( { className: 'tc f6 mb2' }, label( { className: 'black-60' }, [
            'Grundvandsrapporter er også tilgængelige for søgning og download via webkort: ',
            a({ className: 'link dim dib pointer db inline-flex items-center',
                href: 'https://data.geus.dk/geusmap?mapname=rapportdb&lang=da' }, 'data.geus.dk'
            )
        ])),
        form(
            {
                className: 'measure center',
                onsubmit: e => {
                    e.preventDefault();
                    dispatch(searchMsg);
                },

            },
            [
                fieldset( { id: 'upload', className:'ba b--transparent ph0 mh0'}, [
                    legend( { className: 'tc f3 f2-m f2-l fw2 black-90 mv3 nowrap' } , 'Søg i grundvandsdatabasen'),
                    div({ className: 'mt1' }, [
                        label({ className: 'pa2 mb1' }, 'Rapport ID'),
                        input({
                            className: 'mt1 pt2 pb2 pl2 input-reset ba bg-transparent hover-black-80 w-100 br2',
                            value: model.rapportid,
                            type: 'text',
                            autofocus: true,
                            oninput: e => dispatch(rapportIdInputMsg(e.target.value))
                        }),
                    ]),
                    div({ className: 'mv1' }, [
                        label({ className: 'pa2 mb1' }, 'Kommune'),
                        input({
                            className: 'mv1 pt2 pb2 pl2 input-reset ba bg-transparent hover-black-80 w-100 br2',
                            value: model.kommunenoSelect ? model.constLists.searchMunicipality.find(m => m.kode===model.kommunenoSelect[0]).text : model.kommuneno,
                            type: 'text',
                            placeholder: 'Kommunenavn eller -nummer',
                            oninput: e => dispatch(kommuneNoInputMsg(e.target.value))
                        }),
                        model.kommuneno ? select({
                               className: 'pa2 black-70 f6 w-100 br2 ba',
                               id: 'searchMunicipality',
                               name: 'searchMunicipality',
                               size: 5,
                               onchange: e => getSelectedOptions('searchMunicipality', dispatch, kommuneNoSelectInputMsg)
                            },
                            model.constLists.searchMunicipality.filter(m => m.text.toLowerCase().indexOf(model.kommuneno.toLowerCase()) > -1 || m.nummer.indexOf(model.kommuneno) > -1 ).map(
                                function (item, index) {
                                    const selectedOption = model.upload.selectedMunicipality === item.kode;
                                    return option({ value: item.kode, selected: selectedOption }, (item.text + ' ('+item.nummer+')' ) );
                                }
                            )) : '',
                    ]),
                    div({ className: 'mv1' }, [
                        label({ className: 'pa2 mb1' }, 'Fritekstsøgning'),
                        input({
                            className: 'mt1 pt2 pb2 pl2 input-reset ba bg-transparent hover-black-80 w-100 br2',
                            id: 'freeText',
                            value: model.anytext,
                            type: 'text',
                            oninput: e => dispatch(anyTextInputMsg(e.target.value))
                        }),
                    ]),
                    div({ className: 'mv1' }, [
                        label({ className: 'pa2 mb1' }, 'DGU-nr.'),
                        input({
                            className: 'mt1 pt2 pb2 pl2 input-reset ba bg-transparent hover-black-80 w-100 br2',
                            value: model.dgunr,
                            type: 'text',
                            oninput: e => dispatch(dguNrInputMsg(e.target.value)),
                        }),
                    ]),

                    div({ className: 'mv1-ns' }, [
                        label({ className: 'pa2 mb1' }, 'Nøgleord'),
                        select({
                                className: 'mt1 pa1 black-60 f6 mb2 w-100 br2 ba',
                                id: 'searchKeyword',
                                name: 'searchKeyword',
                                size: 10,
                                multiple: true,
                                onchange: e => getSelectedOptions('searchKeyword', dispatch, keywordSelectMsg),
                            },
                            model.constLists.searchKeywords.map(item => option({ value: item.kode}, item.text) )
                        ),
                    ]),
                    div( { className: 'tc'},
                        getSubmitButton('Søg', false)
                    )
                ]),
            ],
        ),
    ]);
}

const tableHeader = thead([
    tr({ className : 'bg-black-10 bb b' }, [
        th({ className: 'pa2 tl nowrap'}, 'Rapport ID'),
        th({ className: 'pa2 tl'}, 'Titel'),
        th({ className: 'pa2 tl'}, 'Rådgiver'),
        th({ className: 'pa2 tl'}, 'Rekvirent'),
    ]),
]);

function searchResultRow(dispatch, result) {
    return tr({ className : 'bb b--silver pointer dim' ,  onclick: () => dispatch(showDetailMsg(result.rapportId)) }, [
        td({ className: 'pa2 tl nowrap' } , result.rapportId),
        td({ className: 'pa2 tl'}, result.titel),
        td({ className: 'pa2 tl nowrap'}, result.raadgiver),
        td({ className: 'pa2 tl nowrap'}, result.rekvirent),
    ]);
}
function pagination(dispatch, model) {
    if (model.queryResult.length <= 25) return '';
    return div({ className: 'mw8 center'}, [
        nav( { className: 'pa2-ns br1' }, [
            model.offset === 0 ? '' : nextLinkLeft(model, dispatch, ((model.offset-24) + '-' + (model.offset))),
            model.queryResult.length - model.offset < 25 ? '' : nextLinkRight(model, dispatch, ((model.offset+26) + '-' + (model.offset+50 > model.queryResult.length ? model.queryResult.length : model.offset+50)))
        ])
    ])
}
function nextLinkLeft(model, dispatch, label) {
    return a({ className: 'link dim dib pa1 pointer db inline-flex items-center f6 ba br2 b--black-50 border-box', onclick: () => dispatch(showPreviousSearchMsg(model.offset)) }, [
        i( { className: 'mr1 fa fa-chevron-left fa black-70' }, ''),
        span( { className: 'black-70' }, label),
    ]);
}
function nextLinkRight(model, dispatch, label) {
    return a({ className: 'ml1 link dim dib pa1 pointer db inline-flex items-center f6 ba br2 b--black-50 border-box', onclick: () => dispatch(showNextSearchMsg(model.offset)) }, [
        span( { className: 'black-70' }, label),
        i( { className: 'ml1 fa fa-chevron-right fa black-70' }, ''),
    ]);
}
export function resultView(dispatch, model) {
    if (model.noSearch || !model.queryResult) return '';
    if (model.queryResult.length === 0) {
        return div({ className: 'mv2 i tc black-50' }, 'Ingen resultater at vise...');
    }
    const rows = model.queryResult.slice(model.offset, model.offset + 25).map(res => searchResultRow(dispatch, res));
    return div( { className: 'tc center w-70'}, [
            div({ className: 'pa2 i tc black-50' },
                'Viser ' + (model.offset+1) + ' til ' +
                (model.offset+25 < model.queryResult.length ? model.offset+25 : model.queryResult.length) +
                ' af ' +model.queryResult.length+' resultater'),
            table({ className: 'mv2 center collapse' }, [
                tableHeader,
                tbody({ className: 'f6' }, rows)
            ]),
            pagination(dispatch, model)
        ]
    );
}